import { TranslateFactoryService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import * as angular from 'angular';
import { DatalayerGeneralConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/constants/ib-datalayer-general-constants';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';

import { SubscriptionModelsUtilService } from './app/core/services/ib-subscription-models-utils-service';
import { IbCLinksService } from 'ib-web-commons/dist/app/core/http-services/angular-statics/services/ib-links-service';
import { DigitalDataService } from 'ib-web-commons/app/core/ib-datalayer/services/ib-digital-data-service';
class InitApp {

    constructor ($translate: angular.translate.ITranslateService,
        private $rootScope: CommonsRootScope,
        private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant,
        private CommonsLanguageAndMarketService: any,
        private SubscriptionModelsUtilService: SubscriptionModelsUtilService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private MonetateUtilsService: MonetateUtilsService,
        private CommonsGetLoginInfoService   : CommonsGetLoginInfoService,
        private TranslateFactoryService: TranslateFactoryService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private DatalayerGeneralConstants: DatalayerGeneralConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private DigitalDataService: DigitalDataService,
        private IbCLinksService: IbCLinksService) {

        //Set translation language to use
        $translate.use(this.SubscriptionModelsAppConstants.lang);
        this.TranslateFactoryService.setLanguage(this.SubscriptionModelsAppConstants.lang);
        this.$rootScope.appLang = this.SubscriptionModelsAppConstants.lang;
        this.$rootScope.appMarket = this.SubscriptionModelsAppConstants.market;
        this.$rootScope.backGroundImage = this.SubscriptionModelsUtilService.getBackGroundURL();
        this.$rootScope.paymentBackgroundImageUrl = this.$rootScope.backGroundImage;
        this.$rootScope.routes = {
            icons: this.SubscriptionModelsAppConstants.iconsRoute,
            images: this.SubscriptionModelsAppConstants.imagesRoute,
            templates: this.SubscriptionModelsAppConstants.templatesRoute,
            links: this.SubscriptionModelsAppConstants.linksRoute
        };
        this.$rootScope.serviceURI = this.SubscriptionModelsAppConstants.servicesURI;
        this.$rootScope.hideAdvancedSearch = true;
        this.$rootScope.phonesList = {};
        this.$rootScope.fullWidth = false;
    }
    active = ():void => {
        this.CommonsSessionStorageService.setPrefix('ib-subscription-models-app');
        this.SubscriptionModelsUtilService.initStorage();
        this.CommonsSessionStorageService.set('flowApp', this.SubscriptionModelsAppConstants.FLOWAPP);
        //Initilize language and market
        const marketLang = this.CommonsLanguageAndMarketService.init();
        this.CommonsSessionStorageService.set('marketLang', marketLang);
        this.SubscriptionModelsUtilService.updateMarketLang(marketLang);
        this.SubscriptionModelsUtilService.getLoggedCookiesInfo();
        this.SubscriptionModelsUtilService.setTitlePage();
        this.DatalayerUtilsService.initializeDatalayer(this.SubscriptionModelsAppConstants.lang, this.SubscriptionModelsAppConstants.market, this.SubscriptionModelsUtilService.getDeviceType());
        this.MonetateUtilsService.initializeMonetate(this.SubscriptionModelsAppConstants.lang, this.SubscriptionModelsAppConstants.market, this.SubscriptionModelsUtilService.getDeviceType());
        this.CommonsGetLoginInfoService.checkCustomerStatus(true);
        const quadrigam = this.SubscriptionModelsUtilService.getQuadrigam();
        const step = this.SubscriptionModelsUtilService.getStep();
        const extendedDigitalDataInfo = {};
        const extendedDataLayerGeneralInfo = {};
        extendedDigitalDataInfo[this.DatalayerGeneralConstants.STEP] = step;
        extendedDataLayerGeneralInfo[this.DatalayerConstants.DATALAYER_INFO.STEP] = step;

        extendedDigitalDataInfo[this.DatalayerGeneralConstants.PROCESS] = this.SubscriptionModelsAppConstants.appName;
        extendedDataLayerGeneralInfo[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = this.SubscriptionModelsAppConstants.appName;
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, extendedDataLayerGeneralInfo, this.SubscriptionModelsUtilService.isUserLogged()); //datalayer_general
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, extendedDigitalDataInfo, this.SubscriptionModelsUtilService.isUserLogged()); //digital_data
        this.DatalayerUtilsService.sendDatalayerEvent(this.SubscriptionModelsAppConstants.DATALAYER_EVENT_TYPES.VIEW);
        this.DigitalDataService.emitViewEvent();
        this.$rootScope.$on('backToMainRoot', (event, goToHome, closeSession) => {
            this.SubscriptionModelsUtilService.backToMain( goToHome, closeSession);
        });
        // Init links
        this.IbCLinksService.getLinks(true, this.SubscriptionModelsAppConstants.SHORT_FLOWAPP)
            .then(() => {
                this.$rootScope.loadedLinks = true;
            });
    };


    $onInit = this.active();


}


InitApp.$inject = ['$translate', '$rootScope', 'SubscriptionModelsAppConstants', 'CommonsLanguageAndMarketService', 'SubscriptionModelsUtilService',
    'DatalayerUtilsService', 'MonetateUtilsService', 'CommonsGetLoginInfoService', 'TranslateFactoryService', 'CommonsSessionStorageService', 'DatalayerGeneralConstants', 'DatalayerConstants', 'DigitalDataService', 'IbCLinksService'
];

/**
 * Iberia Gift Cards Angular Application
 * @module ib-subscription-models-app
 */
angular.module('ib-subscription-models-app', [
    'web-subscription-models-templates',
    'ngAria',
    'ib-commons-ui-components-module',
    'ib-commons-utils-module',
    'ib-commons-constants-module',
    'ib-commons-avios-constants',
    'ib-interceptors-module',
    'ib-commons-filters-module',
    'pascalprecht.translate',
    'ng.deviceDetector',
    'ui.bootstrap',
    'ui.select',
    'ngMessages',
    'ngCookies',
    'ngSanitize',
    'duScroll',
    'rx',
    'tmh.dynamicLocale',
    'ib-subscription-models-configuration-module',
    'ib-ui-city-selector-component-module',
    'ib-commons-precondition-module',
    'ib-subscription-models-routing-module',
    'ib-subscription-models-service-module',
    'ib-subscription-models-generic-error-module',
    'ib-web-menus-module',
    'ib-datalayer-module',
    'ib-commons-login-module',
    'ib-commons-http-service-module',
    'ib-commons-modal-service-module',
    'ib-commons-proxies-module',
    'ib-commons-directives-module',
    'ib-pmt-module',
    'ib-pmt-order-confirmation-module',
    'ib-monetate-module',
    'ib-pmt-subscription-models-confirmation-module',
    'angular-bind-html-compile',
    'ib-content-parser-module',
    'ib-commons-keep-alive-module',
    'ib-commons-http-new-service-module',
    'ib-subscription-models-payments',
    'ib-subscription-models-new-confirmation'

]);

angular.module('ib-subscription-models-app').run(InitApp);
